#import "../fragments/drip-sequence-fragment.graphql"

query GetDripSequence($dripSequenceId: ID!) {
    campaign(id: $dripSequenceId) {
        ...DripSequenceFragment
    }
}
